import { t } from "../../hooks/useAppTranslation";
import styles from "./ExternalControlStyle.module.scss";
import * as Yup from "yup";
import Input from "../Input/Input";
import SelectCustom from "../SelectCustom/SelectCustom";
import {useEffect, useRef, useState} from "react";
import {ICustomSelectValues, IDictionary} from "./ExternalControlContainer";
import {validateNip, validatePesel} from "../Validators/ControlValidator";
import {ISelectSearchProps} from "./ExternalControlForm";


export interface ISubject {
    name: string;
    identifierTypeId: number;
    identifierTypeName?: string;
    id: string;
  }
  interface Props {
    subjectTypes: IDictionary[];
    subjects: ISubject[];
    setFieldValue(args: string, val: any): void;
  }
  
  export const SubjectFormHelper: React.FC<Props> = ({
  subjectTypes,
  setFieldValue,
  subjects,
}) => {  
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [choosedType, setChoosedType] = useState<ICustomSelectValues>();
  const [errorSubjectName, setErrorSubjectName] = useState("");
  const [errorSubjectIdType, setErrorSubjectIdType] = useState("");
  const [errorSubjectId, setErrorSubjectId] = useState("");
  const [previousSearch, setPreviousSearch] = useState("");
  
  const selectCustomRef1 = useRef(null);
  
  useEffect(() => {
    id && setId("");
  }, [choosedType]);
  
  let subjectNameSchema = Yup.string().required(t('external-controls-entity-name-required'));
  let subjectIdTypeSchema = Yup.string().required(t('external-controls-entity-identifier-required'));
  let subjectIdSchema = Yup.string().required(t('external-controls-entity-id-required'));
  
  return (
    <>
      <div className='row'>
        <div className='col-md-4'>
          <Input
            inputId='ext-cnt-subjectName'
            label={t('external-controls-entity-name')}
            placeholder={t('external-controls-entity-name')}
            type='text'
            formik={true}
            maxLength={1000}
            value={name}
            chartsCount={name.length}
            onChange={(e) => setName(e.target.value)}
            errorId='subjectNameError'
            error={errorSubjectName}
            invalid={!!errorSubjectName}
          />
        </div>
        <div className='col-md-3'>
          <SelectCustom
            id='ext-cnt-subjectIdType'
            label={t('external-controls-entity-identifier-type')}
            placeholder={t('external-controls-type')}
            onChange={(value: ICustomSelectValues[]) =>
              setChoosedType(value[0])
            }
            searchFn={(selectProps:ISelectSearchProps) => {
              const options = selectProps.props?.options;
              const includesOptions = options?.find((el: ICustomSelectValues) => el.label.toUpperCase().includes(selectProps.state.search.toUpperCase()));
              (includesOptions && !choosedType) ? setPreviousSearch(selectProps.state.search) : selectProps.state['search'] = previousSearch;
            }}
            options={subjectTypes.map((el) => {
              return {
                label: el.description,
                value: el.entryId,
              };
            })}
            values={
              choosedType
                ? [
                    {
                      label: choosedType.label,
                      value: choosedType.value,
                    },
                  ]
                : []
            }
            keepSelectedInList={true}
            color='#0d47a1'
            containerClassName={styles.selectContainer}
            labelClassName={styles.selectCustomLabel}
            error={errorSubjectIdType}
            errorId='subjectIdType'
            invalid={!!errorSubjectIdType}
            labelHeader={false}
            isMulti={false}
            onClear=''
            dropdownId=''
            disabled={false}
            parentRef={selectCustomRef1}
            className=''
            optionNameVisible={undefined}
          />
        </div>
        <div className='col-md-3'>
          <Input
            inputId='ext-cnt-subjectId'
            label={t('external-controls-entity-identifier')}
            placeholder={t('external-controls-entity-identifier')}
            type='text'
            formik={true}
            value={id}
            onChange={(e) => setId(e.target.value)}
            disabled={!choosedType}
            errorId='subjectId'
            error={errorSubjectId}
            invalid={!!errorSubjectId}
            chartsCount={id.length}
            maxLength={!choosedType ? undefined : choosedType.label === t('g-tin') ? 10 : choosedType.label === t('g-pesel') ? 11 : 24}
          />
        </div>
        <div className='col-md-2'>
          <button
            className={`btn save-btn ${styles.saveButton} uppercase`}
            type='button'
            onClick={async () => {
              const isNotUnique = subjects.find((el: ISubject) => el.id === id);
              const subObj = {
                name,
                identifierTypeId: choosedType?.value,
                identifierTypeName: choosedType?.label,
                id,
              };
              let isEmptyName = false

              await subjectNameSchema.validate(subObj.name)
                .then(() => {
                  isEmptyName = false
                  errorSubjectName && setErrorSubjectName('');
                })
                .catch((err) => {
                  isEmptyName= true
                  setErrorSubjectName(err.message)
                });

              await subjectIdTypeSchema.validate(subObj.identifierTypeId)
                .then(() => {
                  errorSubjectIdType && setErrorSubjectIdType('');

                  subjectIdSchema.validate(subObj.id)
                    .then(() => {
                      errorSubjectId && setErrorSubjectId('');
                      if (
                        subObj.identifierTypeName === t('g-tin') &&
                        !validateNip(subObj.id)
                      ) {
                        setErrorSubjectId(t('external-controls-tin-incorrect'));
                        return;
                      } else if (
                        subObj.identifierTypeName === t('g-pesel') &&
                        !validatePesel(subObj.id)
                      ) {
                        setErrorSubjectId(t('external-controls-pesel-incorrect'));
                        return;
                      }
                      if (!isNotUnique && id !== "" && !isEmptyName) {
                        setFieldValue("subjects", [...subjects, subObj]);
                      } else if (isNotUnique && id)
                        setErrorSubjectId(t('external-controls-entity-id-number-cannot-repeated'));
                    })
                    .catch((err) => setErrorSubjectId(err.message));
                })
                .catch((err) => {
                  setErrorSubjectIdType(err.message);
                  errorSubjectId && setErrorSubjectId('');
                });
            }}
          >
            {t('g-add')}
          </button>
        </div>
      </div>

      {subjects.map((subject: ISubject) => {
        return (
          <div key={subject.id} className={styles.listSpacing}>
            <div className='row' key={subject.id}>
              <div className='col-md-10'>
                <p>
                  {subject.name} - {subject.identifierTypeName}: {subject.id}
                </p>
              </div>
              <div className='col-md-2'>
                <button
                  className='btn cancel-btn uppercase'
                  onClick={() => {
                    const updatedValues = subjects.filter(
                      (el: ISubject) => el.id !== subject.id
                    );
                    setFieldValue("subjects", updatedValues);
                  }}
                >
                  {t('g-delete')}
                  <span className='sr-only'>
                    {subject.name} - {subject.identifierTypeName}: {subject.id}
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
